// extracted by mini-css-extract-plugin
export default {"moreIcon":"totalPreorder_moreIcon__4heJM"};